// import Dashboard from 'Views/Home/dashboard/index3.vue'
import Dashboard from 'Components/Dynamic/qhhk/dashboard.vue'
// import Home from 'Views/Home/home/home'
import Home from 'Components/Dynamic/qhhk/home.vue'
// import Home from 'Components/Dynamic/qhhk/home3.vue'
import Allorder from 'Views/Home/allorder'
import tripList from 'Views/Home/tripList'
import ApprovalList from 'Views/Home/approvalList'
import InvitEmployees from 'Views/Home/userCenter/InvitEmployees'

import UserCenter from 'Views/Home/userCenter'
import Schedule from 'Views/Home/schedule'
import EmpList from 'Views/Home/userCenter/Employee'
import EditEmp from 'Views/Home/userCenter/Employee/EditEmp'
import revise from 'Views/Home/userCenter/Employee/revise'

import CommonInfo from 'Views/Home/userCenter/CommonInfo'
import EditAddress from 'Views/Home/userCenter/CommonInfo/EditAddress'
import EditContact from 'Views/Home/userCenter/CommonInfo/EditContact'
import EditConta1 from 'Views/Home/userCenter/CommonInfo/EditConta1'
import NeedOrder from 'Views/Home/userCenter/NeedOrder'
import Company from 'Views/Home/userCenter/Company'
import UserInfo from 'Views/Home/userCenter/UserInfo'
import Settings from 'Views/Home/userCenter/Settings'
import closeAccount from 'Views/Home/userCenter/Settings/closeAccount'
import About from 'Views/Home/userCenter/Settings/About'
import ModifyMobile from 'Views/Home/userCenter/Settings/ModifyMobile'
import ModifyPassword from 'Views/Home/userCenter/Settings/ModifyPassword'

export default [
  // {
  // 	name: 'dashboard',
  // 	path: '/dashboard',
  // 	component: Dashboard,
  // 	meta: {
  // 		include: ['Dashboard'],
  // 		index: 0
  // 	},
  // 	children: [
  // 		{
  // 			name: 'home',
  // 			path: '/home',
  // 			component: Home,
  // 			meta: {
  // 				include: ['Home', 'ApprovalList', 'UserCenter'],
  // 				index: 0
  // 			}
  // 		},
  // 		{
  // 			name: 'allorder',
  // 			path: '/allorder',
  // 			component: Allorder,
  // 			meta: {
  // 				include: ['Home', 'ApprovalList', 'UserCenter'],
  // 				index: 0
  // 			}
  // 		},
  // 		{
  // 			name: 'tripList',
  // 			path: '/tripList',
  // 			component: tripList,
  // 			meta: {
  // 				include: ['Home', 'ApprovalList', 'UserCenter'],
  // 				index: 0
  // 			}
  // 		},
  // 		{
  // 			name: 'approvalList',
  // 			path: '/approvalList',
  // 			component: ApprovalList,
  // 			meta: {
  // 				include: ['Home', 'ApprovalList', 'UserCenter'],
  // 				index: 0
  // 			}
  // 		},
  // 		{
  // 			name: 'userCenter',
  // 			path: '/userCenter',
  // 			component: UserCenter,
  // 			meta: {
  // 				include: ['Home', 'Allorder', 'ApprovalList', 'UserCenter'],
  // 				index: 0
  // 			}
  // 		}
  // 	]
  // },

  {
    name: 'scheduleHistroy',
    path: '/schedule/histroy',
    component: Schedule,
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'approvalList',
    path: '/userCenter/approvalList',
    component: ApprovalList,
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'invitEmployees',
    path: '/userCenter/invitEmployees',
    component: InvitEmployees,
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'empList',
    path: '/userCenter/empList',
    component: EmpList,
    meta: {
      include: ['EmpEdit', 'EmpList'],
      index: 1
    }
  },
  {
    name: 'empEdit',
    path: '/userCenter/empEdit/:id?',
    component: EditEmp,
    props: true,
    meta: {
      include: ['EmpList'],
      index: 2
    }
  },
  {
    name: 'revise',
    path: '/userCenter/revise/:id?',
    component: revise,
    props: true,
    meta: {
      include: ['EmpList'],
      index: 2
    }
  },
  {
    name: 'CommonInfo',
    path: '/userCenter/CommonInfo',
    component: CommonInfo,
    meta: {
      index: 1
    }
  },
  {
    name: 'EditAddress',
    path: '/userCenter/CommonInfo/EditAddress/:id?',
    component: EditAddress,
    props: true,
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'EditContact',
    path: '/userCenter/CommonInfo/EditContact/:id?',
    component: EditContact,
    props: true,
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'EditConta1',
    path: '/userCenter/CommonInfo/EditConta1/:id?',
    component: EditConta1,
    props: true,
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'needOrder',
    path: '/userCenter/NeedOrder/:id?',
    props: true,
    component: NeedOrder,
    meta: {
      index: 1
    }
  },
  {
    name: 'company',
    path: '/userCenter/company',
    component: Company,
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'userInfo',
    path: '/userCenter/userInfo',
    component: UserInfo,
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'settings',
    path: '/userCenter/settings',
    component: Settings,
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'closeAccount',
    path: '/userCenter/settings/closeAccount',
    component: closeAccount,
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'about',
    path: '/userCenter/settings/about',
    component: About,
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'modifyMobile',
    path: '/userCenter/settings/modifyMobile',
    component: ModifyMobile,
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'modifyPassword',
    path: '/userCenter/settings/modifyPassword',
    component: ModifyPassword,
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'MessageOrder',
    path: '/userCenter/message/order',
    component: (resolve) => require(['Views/Home/userCenter/Message/order'], resolve),
    meta: {
      include: ['MessageOrder'],
      index: 1
    }
  },
  {
    name: 'MessageList',
    path: '/userCenter/message/list',
    component: (resolve) => require(['Views/Home/userCenter/Message/list'], resolve),
    meta: {
      include: ['MessageList'],
      index: 1
    }
  },
  {
    name: 'noticeDetail',
    path: '/userCenter/noticeDetail/:id?',
    component: (resolve) => require(['Views/Home/userCenter/Notice/Detail'], resolve),
    props: true,
    meta: {
      include: ['NoticeDetail', 'MessageList'],
      index: 2
    }
  },
  {
    name: 'reserveRebook',
    path: '/userCenter/reserveRebook',
    component:(resolve) => require(['Views/Home/userCenter/reserveRebook/index'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'billInvoice',
    path: '/userCenter/billInvoice',
    component:(resolve) => require(['Views/Home/userCenter/billInvoice/index'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'trainsInvoice',
    path: '/userCenter/billInvoice/trainsInvoice',
    component:(resolve) => require(['Views/Home/userCenter/billInvoice/trainsInvoice/index'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'invoiceManagement',
    path: '/userCenter/billInvoice/trainsInvoice/invoiceManagement',
    component:(resolve) => require(['Views/Home/userCenter/billInvoice/trainsInvoice/invoiceManagement.vue'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'invoiceHeaderManage',
    path: '/userCenter/billInvoice/trainsInvoice/invoiceHeaderManage',
    component:(resolve) => require(['Views/Home/userCenter/billInvoice/trainsInvoice/invoiceHeaderManage.vue'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'openInvoiceList',
    path: '/userCenter/billInvoice/trainsInvoice/openInvoiceList',
    component:(resolve) => require(['Views/Home/userCenter/billInvoice/trainsInvoice/openInvoiceList.vue'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'openInvoiceDetail',
    path: '/userCenter/billInvoice/trainsInvoice/openInvoiceDetail',
    component:(resolve) => require(['Views/Home/userCenter/billInvoice/trainsInvoice/openInvoiceDetail.vue'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'theLogin12306',
    path: '/userCenter/billInvoice/login/theLogin12306',
    component:(resolve) => require(['Views/Home/userCenter/billInvoice/login/theLogin12306.vue'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'amapRedirect',
    path: '/amapRedirect',
    component: (resolve) => require(['Views/Home/amapRedirect'], resolve),
    meta: {
      include: [],
      index: 0
    }
  }
]
